import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <SectionHeading
        eyebrow="话题分类"
        title="按你关心的话题逛"
        desc="六个长期更新的内容方向，每一个都有稳定的整理节奏。"
      />

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/40"
          >
            <div className="flex items-center justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                <i className={`${cat.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <span className="font-label text-xs text-foreground-500">{cat.count} 篇整理</span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
              {cat.name}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 font-label text-sm font-medium text-primary-700">
              进入分类
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}